import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { Component } from 'react';
import SpotifyWebApi from 'spotify-web-api-js';
import SearchInput from './SearchInput';
import axios from 'axios';
import Notfound from './NotFound';
import Discovered from './Discovered';
import './styles.css';


class DiscoverButton extends Component {

  state = {loaded: false,
            discovered: {}}

  discover = (list) => {

    const spotify = new SpotifyWebApi();
    const disc = {};
    if(spotify.getAccessToken() == null){
      const authOptions = {
        url: 'https://accounts.spotify.com/api/token',
        headers: {
          Authorization: `Basic ${btoa(SearchInput.CLIENT_ID + ':' + SearchInput.CLIENT_SECRET)}`,
        },
        data: 'grant_type=client_credentials',
      };
  
      axios
        .post(authOptions.url, authOptions.data, { headers: authOptions.headers })
        .then((response) => {
          const token = response.data.access_token;
          //const spotify = new SpotifyWebApi();
          spotify.setAccessToken(token);
          console.log("got token from finder")
        })
        .catch((error) => {
          console.error(error);
        });
    } else {

        const id = this.props.id;
        var counter = 0
        
        const encounteredIds = new Set(); // To track encountered track IDs
        const encounteredTitles = new Set(); // To track encountered track titles (case insensitive)
        
        list.forEach((code, index) => {
          spotify.getAlbumTracks(code.id, { limit: 50 })
            .then((album) => {
              album.items.forEach((track) => {
                if (track.artists.length > 0 && track.artists.some((artist) => artist.id === id)) {
                  if (!encounteredIds.has(track.id) && !encounteredTitles.has(track.name)) {
                  track.artists.forEach((artist) => {
                    if (artist.id !== id) {
                      const artistName = artist.name;
      
                        if (!disc.hasOwnProperty(artistName)) {
                          disc[artistName] = [];
                        }

                        track['img'] = code.images[0].url;

                        spotify.getArtist(artist.id).then(
                          function (data) {
                            if(data.images[0] !== undefined){
                              disc[artistName]["artistimg"] = data.images[0].url
                            }
                            disc[artistName]["popularity"] = data.popularity
                          },
                          function (err) {
                            if(err.status == 429){
                              counter++
                              console.log(err.status)
                            }
                            
                          }
                        );

                        disc[artistName].push(track);
        
                        
                      
                    }
                  })};
                  encounteredIds.add(track.id);
                  encounteredTitles.add(track.name);
                }
              });
              
            })
            .catch((err) => {
              if(err.status == 429){
                list.length = index+1
                alert("Server overload, sorry for the inconvenience")
                console.log(err)
              }
            });
        });
        

      /*setTimeout(function() {
        //console.log("This message appears after a 2-second delay.");
      }, 1000);*/

      

    }
    
    //console.log(resultAdv)
    console.log(disc);
    setTimeout(() => {
      this.setState({
        loaded: true,
        discovered: disc,
      });
    }, 1000);
    
   if(counter > 0){
    alert("Some photos haven't loaded because of server overload, sorry for the inconvenience")
   }

      

  }


  componentDidUpdate(prevProps){
    if(this.props.id !== prevProps.id){
      this.setState({loaded: false})
      this.props.onFooter();
    }
  }
  handleFooterPosition = (fixed) => {
    this.props.onFinalFooterSet();
  };


render(){
  return(
    <div>
<div class="container">
    <div class="row">
      
      <div class="col">
      <input type="submit" value="DISCOVER!" class="btn" onClick={() => { this.discover(this.props.tracks)}} style={{ background: '#D9E724', borderColor: '#8b008b', color:'black', fontWeight: "bold"}}/>
      </div>
     
    </div>
    <div class="row">
      <div class="col">{this.state.loaded === true ? (
        //console.log(Object.keys(this.state.discovered).length)
  (this.props.id !== "") ? (
     Object.keys(this.state.discovered).length > 0 ? (
      <Discovered discovered={this.state.discovered} onFooterPosition={this.handleFooterPosition}/>
      //console.log("C'E ROBA")
    ) : (
      <Notfound discover={true}/>
    )
  ) : (
    <div>
      {<h1 style={{marginTop: '30px'}}>The artist is missing!</h1>}
    </div>
  )
) : (
  ""
)}

</div>

    </div>
    </div>
    </div>
    
  )
}
  
}

export default DiscoverButton;